<template>
	<div>
		<ly-datalist url="shop" infourl="shop_add" title="门店列表" add="yes" addtxt="新建门店" >
			<table class="table">
		        <thead>
		          <tr>
		            <th>门店ID</th>
		            <th>门店显示名称</th>
		            <th>所在区域</th>
		            <th>门店电话</th>
		            <th>详细地址</th>
		            <th>微信端车主可见性</th>
		            <th>
		            	操作
		            </th>
		          </tr>
		        </thead>
		        <tbody>
		          <tr v-for="item in data">
		            <td>{{item.shop_id}}</td>
		            <td>{{item.name}}</td>
		            <td>{{item.area}}</td>
		            <td>{{item.phone}}</td>
		            <td>{{item.address}}</td>
		            <td>{{item.is_wx_show ? '是' : '否'}}</td>
		            <td>
		            	<a v-link="{name:'shop_info',params : {sid: item.id}}" class="button">查看</a>
						<a href="javascript:;" class="sort-btn" title="向上移动"
		            		@click="sortUp(item.id,$index)"
		            		v-if="$index != 0">
		            		<i class="glyphicon glyphicon-arrow-up"></i>
		            	</a>
		            	<a href="javascript:;" class="sort-btn" title="向下移动" 
		            		@click="sortDown(item.id,$index)"
		            		v-if="$index != (data.length - 1)">
		            		<i class="glyphicon glyphicon-arrow-down"></i> 
		            	</a>
		            </td>
		          </tr>
		        </tbody>
		    </table>
		</ly-datalist>
	</div>
</template>
<script>
	var Common = require('../utils/Common.js');
	var Http = require('../utils/HttpHelper.js');
	/**
	* 组件对象
	*/
	var Component = {
		data : function(){
			return {
				data : []
			}
		},
		methods : {
			/**
			* 向上移动
			*/
			sortUp : function(id,index){
				this.data = Common.sortArr(this.data,index,index - 1);
				Http.shop.up({
					data : {id : id}
				});
			},
			/**
			* 向下的移动
			*/
			sortDown : function(id,index){
				this.data = Common.sortArr(this.data,index,index + 1);
				Http.shop.down({
					data : {id : id}
				});
			}
		},
		components :  {
			'ly-datalist' : require('../components/Datalist.vue')
		},
		events : {
			datalist : function(data){
				this.data = data;
			}
		}
	};
	module.exports = Component;
</script>


/** WEBPACK FOOTER **
 ** shop_list.vue?7577923d
 **/